import { __assign } from "tslib";
import { ATDealersLinks, ATGroupLinks } from '../footer-shared-links';
export var FooterFarmLinks = function () {
    return [
        __assign({}, ATGroupLinks),
        {
            rowHeading: 'Private customers',
            subNav: [
                {
                    url: '/farm/sell',
                    displayText: 'Sell my farm machinery',
                    routerLink: false,
                },
                {
                    url: '/farm/sell-my-farm-machinery/advertising-prices',
                    displayText: 'Advertising costs',
                    routerLink: false,
                },
                {
                    url: '/safety_and_security_centre',
                    displayText: 'Buying & selling safely online',
                    routerLink: false,
                },
                {
                    url: '/terms-and-conditions/advertising',
                    displayText: 'Terms & conditions',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Quick search',
            subNav: [
                {
                    url: '/farm/farm-machinery/browse-all-makes',
                    displayText: 'All farm machinery makes',
                    routerLink: false,
                },
                {
                    url: '/farm/content',
                    displayText: 'Farm reviews',
                    routerLink: false,
                },
                {
                    url: '/farm/dealer-directory',
                    displayText: 'Farm dealers',
                    routerLink: false,
                },
            ],
        },
        __assign({}, ATDealersLinks),
    ];
};
export default FooterFarmLinks;
